import React from "react";

import { GenericStudioAdminPanel } from "../../sdk/studio/react";

/**
 * RestaurantStudioAdminPanel
 *
 * Spécialisation déclarative du GenericStudioAdminPanel.
 * Toute la gestion générique du mode embedded/fullscreen est déléguée
 * au framework Studio.
 */
export default function RestaurantStudioAdminPanel(props) {
  return (
    <GenericStudioAdminPanel
      {...props}
      className="restaurant-studio-admin-panel"
    />
  );
}
